import { render } from "./PCheckbox.vue?vue&type=template&id=dc5ed630&scoped=true&lang=pug"
import script from "./PCheckbox.vue?vue&type=script&lang=js"
export * from "./PCheckbox.vue?vue&type=script&lang=js"

import "./PCheckbox.vue?vue&type=style&index=0&id=dc5ed630&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc5ed630"],['__file',"src/common/inputs/PCheckbox.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "dc5ed630"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('dc5ed630', __exports__)) {
    api.reload('dc5ed630', __exports__)
  }
  
  module.hot.accept("./PCheckbox.vue?vue&type=template&id=dc5ed630&scoped=true&lang=pug", () => {
    api.rerender('dc5ed630', render)
  })

}


export default __exports__